import React from 'react'

import { interWbNavigate } from 'inter-webview-bridge'
import LeftArrowIcon from 'inter-frontend-svgs/lib/orangeds/SM/arrow-left'
import HomeIcon from 'inter-frontend-svgs/lib/orangeds/SM/home'

import { Container, HeaderIconButton, HeaderTitle } from './styles'
import useGoBack from '../../hooks/useGoBack'

type Props = {
  titleRoute: string
  goBackNative?: boolean
}

export const AppBar: React.FC<Props> = ({ titleRoute, goBackNative }) => {
  const goBack = useGoBack({ goBackNative })

  return (
    <Container>
      <HeaderIconButton onClick={goBack}>
        <LeftArrowIcon height={24} width={24} color="var(--orange500)" />
      </HeaderIconButton>

      <HeaderTitle
        className="title"
        color="typography"
        colorWeight={500}
        variant="headline-h3"
        semiBold
      >
        {titleRoute}
      </HeaderTitle>

      <HeaderIconButton onClick={() => interWbNavigate.requestGoBack()}>
        <HomeIcon height={24} width={24} color="var(--orange500)" />
      </HeaderIconButton>
    </Container>
  )
}
